module.exports = __webpack_public_path__ + "static/media/nd1.ba1ec75c.webp";